//@flow
import * as React from 'react';
import DefaultBulkViewEmptyState from 'common/entity/BulkViewEmptyState';

export const PjpBulkViewEmptyState = props => {
    return <DefaultBulkViewEmptyState {...props} disableAddButton />;
};

export default PjpBulkViewEmptyState;
